import { Row, Col, Form, Input, Divider, Modal, FormInstance } from 'antd';
import { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import RoundShape from '../../Atoms/RoundShape/RoundShape';
import Switch from '../../Molecules/Switch/Switch';
import TaskType from '../../../models/TaskType';
import './TaskTypeForm.less';

/**
 * @component TaskTypeForm.tsx
 * @description TaskTypeForm component to create and edit a task type.
 * @return { Component }
 */
interface TaskTypeFormProps {
  form: FormInstance;
  isEdit: boolean;
  isModal: (isModal: boolean, taskType: TaskType) => void;
  taskUpdate: any;
}
function TaskTypeForm(props: TaskTypeFormProps) {
  const { confirm } = Modal;
  const [background, setBackground] = useState('#D9D9D9');
  const [open, setOpen] = useState(false);
  const [enableTask, setEnableTask] = useState(false);
  const handleChangeComplete = (color: any) => {
    setBackground(color.hex);
    props.form.setFieldsValue({
      color: color.hex.replace('#', ''),
    });
    setOpen(!open);
  };
  const colorOnClick = (color: string) => {
    setOpen(!open);
    props.form.setFieldsValue({
      color: color.replace('#', ''),
    });
  };
  const onChangeColor = (color: any) => {
    setBackground(color.hex);
    props.form.setFieldsValue({
      color: color.hex.replace('#', ''),
    });
  };
  const taskDelate = () => {
    confirm({
      title: '¿Quieres eliminar el tipo de tarea?',
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          Esta acción lo eliminará por completo <br /> y es irreversible.
        </>
      ),
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk() {
        props.isModal(false, props.taskUpdate.task);
      },
      onCancel() {
        props.isModal(true, {});
      },
    });
  };
  const isEnabled = (enable: boolean) => {
    setEnableTask(enable);
    props.form.setFieldsValue({
      activo: enable,
    });
  };
  useEffect(() => {
    if (props.isEdit) {
      setEnableTask(props.taskUpdate.task.activo);
      props.form.setFieldsValue({
        tipotarea: props.taskUpdate.task.tipotarea,
        color: props.taskUpdate.task.color,
        activo: props.taskUpdate.task.activo,
      });
      setBackground('#' + props.taskUpdate.task.color);
    } else {
      props.form.resetFields();
      setBackground('#D9D9D9');
    }
  }, [props.form, props.isEdit, props.taskUpdate]);

  return (
    <div className="org-task-form">
      <Row>
        <Col span={24}>
          <Form layout={'vertical'} form={props.form} name="TaskTypeForm">
            <Form.Item
              name={'tipotarea'}
              style={{fontWeight: 'bold'}}
              label="Nombre de Tipo de Tarea"
              rules={[
                {
                  required: true,
                  message: 'por favor digite el tipo de tarea',
                },
              ]}
            >
              <Input required placeholder={'Inspección'} />
            </Form.Item>
            <Input.Group className="org-task-form__group" compact>
              <Form.Item
                name={'color'}
                required={true}
                style={{fontWeight: 'bold'}}
                label="Elige un color para el tipo de tarea"
                className="org-task-form__color__item"
              >
                <div>
                  <RoundShape
                    key={0}
                    color={background}
                    width={'32px'}
                    height={'32px'}
                    colorOnClick={colorOnClick}
                    isEdit={true}
                  />
                </div>
              </Form.Item>
              {open && (
                <SketchPicker
                  disableAlpha={true}
                  className="org-task-form__picker"
                  color={background}
                  onChange={onChangeColor}
                  onChangeComplete={handleChangeComplete}
                />
              )}
            </Input.Group>
            {props.isEdit && <Divider />}
            {props.isEdit && (
              <Form.Item name="activo" className={'org-tasl-type-form__switch'}>
                <Switch value={enableTask} isEnabled={isEnabled} />
              </Form.Item>
            )}
            {props.isEdit && (
              <div className="org-task-form__delete">
                <div className="icon-delete" onClick={taskDelate}>
                  <DeleteOutlined /> Eliminar
                </div>
              </div>
            )}
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default TaskTypeForm;
